import { Component, Input } from '@angular/core';
import { ShopeeAttribute, multi_lang } from '../shopee-attribute.types';

type ControlKind = 'select' | 'multiselect' | 'tags' | 'text' | 'number-unit' | 'date';

@Component({
  selector: 'shopee-attribute-field',
  templateUrl: './shopee-attribute-field.component.html',
  styleUrls: ['./shopee-attribute-field.component.scss'],
  standalone: false
})
export class ShopeeAttributeFieldComponent {
  @Input() attribute!: ShopeeAttribute;

  get label(): string {
    return this.getLang(this.attribute.multi_lang) ?? this.attribute.name;
  }

  /** Colapsa os ~12 *ngIf em poucos casos. */
  get kind(): ControlKind {
    const { input_type: it, input_validation_type: vt, format_type: ft } = this.attribute.attribute_info;
    if (it === 3 && vt === 4) return 'date';
    if ((it === 2 || it === 3) && ft === 2) return 'number-unit';
    if (it === 4 || it === 5) return this.hasOptions ? 'multiselect' : 'tags'; // <-- aqui
    if (it === 1) return 'select';
    if (it === 2 && (vt === 1 || vt === 2)) return 'select';
    return 'text';
    }

  /** Memoizado -> habilita virtual scroll em listas grandes. */
  get options() {
    if (!this.attribute._options) {
      this.attribute._options = (this.attribute.attribute_value_list ?? []).map(v => ({
        nzLabel: this.getLang(v.multi_lang) ?? v.name,
        nzValue: v.value_id
      }));
    }
    return this.attribute._options;
  }

  get maxMultiple(): number {
    return this.attribute.attribute_info.max_value_count ?? Infinity;
  }

  get hasUnits(): boolean {
    return (this.attribute.attribute_info.attribute_unit_list?.length ?? 0) > 0;
  }

  /** Filhos dependentes do valor atualmente selecionado. */
  get activeChildren(): ShopeeAttribute[] {
    const v = this.attribute.datavalue;
    const list = this.attribute.attribute_value_list ?? [];
    const ids = Array.isArray(v) ? v : (v != null ? [v] : []);
    return ids.reduce((acc, id) => {
                const found = list.find(o => o.value_id === id);
                if (found?.child_attribute_list) {
                    acc.push(...found.child_attribute_list);
                }
                return acc;
                }, [] as ShopeeAttribute[]);
  }

  trackByAttr = (_: number, a: ShopeeAttribute) => a.attribute_id;

  private getLang(ml?: multi_lang[]): string | null {
    return ml?.find(d => d.language === 'pt-BR')?.value ?? null;
  }

  

get hasOptions(): boolean {
  return (this.attribute.attribute_value_list?.length ?? 0) > 0;
}


}